import { render, staticRenderFns } from "./PicturePicker.vue?vue&type=template&id=04f95065"
import script from "./PicturePicker.vue?vue&type=script&lang=js"
export * from "./PicturePicker.vue?vue&type=script&lang=js"
import style0 from "./PicturePicker.vue?vue&type=style&index=0&id=04f95065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VChip,VFileInput,VIcon,VImg})
